import { render, staticRenderFns } from "./uploadMedicalOrder.view.vue?vue&type=template&id=4f7e16d0&scoped=true"
import script from "./uploadMedicalOrder.view.vue?vue&type=script&lang=js"
export * from "./uploadMedicalOrder.view.vue?vue&type=script&lang=js"
import style0 from "./uploadMedicalOrder.view.vue?vue&type=style&index=0&id=4f7e16d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7e16d0",
  null
  
)

export default component.exports